import { Action } from '@ngrx/store';
import { Reference } from '../../utils/action-helper.util';
import { Error } from '../_models/auth.models';
import { Purge } from '../_models/purge.model';

/**
 * Purge action types
 */
export enum PurgeActionTypes {
  GET_PURGE = '[Purge] Get Purge',
  GET_PURGE_SUCCESS = '[Purge] Get Purge Success',
  GET_PURGE_FAILED = '[Purge] Get Purge Failed',
  UPDATE_PURGE = '[Purge] Update Purge',
  UPDATE_PURGE_SUCCESS = '[Purge] Update Purge Success',
  UPDATE_PURGE_FAILED = '[Purge] Update Purge Failed',
  LOAD_PURGES = '[Purge] Purges',
  LOAD_PURGES_SUCCESS = '[Purge] Purges Success',
  LOAD_PURGES_FAILED = '[Purge] Purges Failed',
  ACTIVATE_PURGES = '[Purge] Activate Purges',
  ACTIVATE_PURGES_SUCCESS = '[Purge] Activate Purge Success',
  ACTIVATE_PURGES_FAILED = '[Purge] Activate Purge Failed',
  DELETE_PURGE = '[Purge] Delete Purge',
  DELETE_PURGE_SUCCESS = '[Purge] Delete Purge Success',
  DELETE_PURGE_FAILED = '[Purge] Delete Purge Failed',
  CREATE_PURGE = '[Purge] Create Purge',
  CREATE_PURGE_SUCCESS = '[Purge] Create Purge Success',
  CREATE_PURGE_FAILED = '[Purge] Create Purge Failed',
  EXECUTE_PURGE = '[Purge] Execute Purge',
  EXECUTE_PURGE_SUCCESS = '[Purge] Execute Purge Success',
  EXECUTE_PURGE_FAILED = '[Purge] Execute Purge Failed',
  RESET = '[Purge] Reset',
}

/**
 * Operations
 */

export class ActivatePurge extends Reference implements Action {
  readonly type = PurgeActionTypes.ACTIVATE_PURGES;

  constructor(public payload: Purge) {
    super();
  }
}

export class ActivatePurgeSuccess extends Reference implements Action {
  readonly type = PurgeActionTypes.ACTIVATE_PURGES_SUCCESS;

  constructor() {
    super();
  }
}

export class ActivatePurgeFailed extends Reference implements Action {
  readonly type = PurgeActionTypes.ACTIVATE_PURGES_FAILED;

  constructor(public payload: Error) {
    super();
  }
}
export class LoadPurges implements Action {
  readonly type = PurgeActionTypes.LOAD_PURGES;

  constructor(public tableId: string, public force?: boolean) {}
}

export class LoadPurgesSuccess implements Action {
  readonly type = PurgeActionTypes.LOAD_PURGES_SUCCESS;

  constructor(public tableId: string, public payload: Array<Purge>) {}
}

export class LoadPurgesFailed implements Action {
  readonly type = PurgeActionTypes.LOAD_PURGES_FAILED;

  constructor(public payload: Error) {}
}

export class DeletePurge extends Reference implements Action {
  readonly type = PurgeActionTypes.DELETE_PURGE;

  constructor(public tableId: string, public purgeId: string) {
    super();
  }
}

export class DeletePurgeSuccess extends Reference implements Action {
  readonly type = PurgeActionTypes.DELETE_PURGE_SUCCESS;

  constructor(public tableId: string, public purgeId: string) {
    super();
  }
}

export class DeletePurgeFailed extends Reference implements Action {
  readonly type = PurgeActionTypes.DELETE_PURGE_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class CreatePurge extends Reference implements Action {
  readonly type = PurgeActionTypes.CREATE_PURGE;

  constructor(public payload: Purge) {
    super();
  }
}

export class CreatePurgeSuccess extends Reference implements Action {
  readonly type = PurgeActionTypes.CREATE_PURGE_SUCCESS;

  constructor(public payload: Purge) {
    super();
  }
}

export class CreatePurgeFailed extends Reference implements Action {
  readonly type = PurgeActionTypes.CREATE_PURGE_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class ExecutePurge extends Reference implements Action {
  readonly type = PurgeActionTypes.EXECUTE_PURGE;

  constructor(public payload: Purge) {
    super();
  }
}

export class ExecutePurgeSuccess extends Reference implements Action {
  readonly type = PurgeActionTypes.EXECUTE_PURGE_SUCCESS;

  constructor(public payload: Purge) {
    super();
  }
}

export class ExecutePurgeFailed extends Reference implements Action {
  readonly type = PurgeActionTypes.EXECUTE_PURGE_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class GetPurge implements Action {
  readonly type = PurgeActionTypes.GET_PURGE;

  constructor(public purgeId: string) {}
}

export class GetPurgeSuccess implements Action {
  readonly type = PurgeActionTypes.GET_PURGE_SUCCESS;

  constructor(public purgeId: string, public payload: Purge) {}
}

export class GetPurgeFailed implements Action {
  readonly type = PurgeActionTypes.GET_PURGE_FAILED;

  constructor(public payload: Error) {}
}

export class UpdatePurge extends Reference implements Action {
  readonly type = PurgeActionTypes.UPDATE_PURGE;

  constructor(public payload: Purge) {
    super();
  }
}

export class UpdatePurgeSuccess extends Reference implements Action {
  readonly type = PurgeActionTypes.UPDATE_PURGE_SUCCESS;

  constructor(public payload: Purge) {
    super();
  }
}

export class UpdatePurgeFailed extends Reference implements Action {
  readonly type = PurgeActionTypes.UPDATE_PURGE_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class Reset implements Action {
  readonly type = PurgeActionTypes.RESET;

  constructor() {}
}

/**
 * Available types
 */
export type Actions =
  | LoadPurges
  | LoadPurgesSuccess
  | LoadPurgesFailed
  | DeletePurge
  | DeletePurgeSuccess
  | DeletePurgeFailed
  | CreatePurge
  | CreatePurgeSuccess
  | CreatePurgeFailed
  | ExecutePurge
  | ExecutePurgeSuccess
  | ExecutePurgeFailed
  | GetPurge
  | GetPurgeSuccess
  | GetPurgeFailed
  | UpdatePurge
  | UpdatePurgeSuccess
  | UpdatePurgeFailed
  | Reset
  | ActivatePurge
  | ActivatePurgeSuccess
  | ActivatePurgeFailed;
  ;
